import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cdc370a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "async-loader",
  "aria-busy": true,
  role: "status"
}
const _hoisted_2 = {
  key: 0,
  class: "label"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AsyncLoader',
  props: {
		label: {
			type: String,
			default: "Chargement…",
		},
		size: {
			type: String,
			default: "32px",
		},
	},
  setup(__props) {

	/**
	 * Loader léger destiné à `defineAsyncComponent({ loadingComponent })`.
	 *
	 * Vue n'affiche ce composant que si le chunk met plus de `delay` ms à
	 * arriver (200 ms typiquement). Sur les bonnes connexions, l'utilisateur
	 * ne voit jamais le spinner — il sert uniquement à donner un signal
	 * visuel pour les chunks lourds (Leaflet, Mapbox, modals avec QR code,
	 * etc.) ou les réseaux lents.
	 *
	 * Le label est optionnel (passé via prop `label`). Sans label,
	 * on n'affiche qu'un spinner centré qui ne dépend pas du contexte —
	 * convient autant pour un modal que pour une zone carte.
	 */
	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "spinner",
      style: _normalizeStyle({ width: __props.size, height: __props.size })
    }, null, 4),
    (__props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})